// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"37bdeb27","361":"b9bdd007","787":"dbc3bcaf"}[chunkId] + ".chunk.js";
};